import { useState } from "react";
import { Sparkles, Flame, PackagePlus } from "lucide-react";
import { mediaUrl } from "@/lib/pricing";
import { PhotoLightbox } from "./PhotoLightbox";
import { BRL } from "./PixPayment";
import { Stepper } from "./ToursSection";

const ICON = { limpeza: Sparkles, churrasco: Flame, outro: PackagePlus };
export const unitLabel = (u) => (u === "diaria" ? "por diária" : "por estadia");

export const addonsTotal = (addons, picked, nights) =>
  picked.reduce((acc, p) => {
    const a = addons.find((x) => x.id === p.addon_id);
    return a ? acc + Number(a.price) * p.qty * (a.unit === "diaria" ? nights : 1) : acc;
  }, 0);

// Optional extras for the stay: cleaning packages, barbecue kit, etc.
export const AddonsPicker = ({ addons, picked, setPicked, nights }) => {
  const [gallery, setGallery] = useState(null);
  if (!addons.length) return null;
  const get = (id) => picked.find((p) => p.addon_id === id);
  const toggle = (id) => setPicked(get(id) ? picked.filter((p) => p.addon_id !== id) : [...picked, { addon_id: id, qty: 1 }]);

  return (
    <div className="mb-4 rounded-2xl border border-amber-200 bg-amber-50/60 p-4" data-testid="addons-picker">
      {gallery && <PhotoLightbox images={gallery.images} title={gallery.name} onClose={() => setGallery(null)} />}
      <p className="text-[11px] font-bold text-amber-800 uppercase mb-3 flex items-center gap-1.5"><PackagePlus className="w-3.5 h-3.5" /> Serviços adicionais (opcionais)</p>
      <div className="space-y-2.5">
        {addons.map((a) => {
          const p = get(a.id);
          const Icon = ICON[a.category] || PackagePlus;
          return (
            <div key={a.id} className={`bg-white rounded-xl border p-3 transition-colors ${p ? "border-amber-400" : "border-amber-100"}`} data-testid={`addon-${a.id}`}>
              <div className="flex gap-3">
                {a.images?.[0] ? (
                  <button type="button" onClick={() => setGallery(a)} className="shrink-0 h-14 w-14 rounded-lg overflow-hidden" aria-label={`Ver fotos de ${a.name}`} data-testid={`addon-photo-${a.id}`}>
                    <img src={mediaUrl(a.images[0])} alt={a.name} className="w-full h-full object-cover" />
                  </button>
                ) : <div className="shrink-0 h-14 w-14 rounded-lg bg-amber-100 flex items-center justify-center text-amber-600"><Icon size={20} /></div>}
                <label className="flex-1 min-w-0 cursor-pointer">
                  <span className="flex items-start gap-2">
                    <input type="checkbox" checked={Boolean(p)} onChange={() => toggle(a.id)} className="mt-0.5 w-4 h-4 accent-[#0A66C2] shrink-0" data-testid={`addon-toggle-${a.id}`} />
                    <span className="min-w-0">
                      <span className="block text-sm font-bold text-slate-800">{a.name}</span>
                      <span className="block text-xs text-slate-500">{BRL(a.price)} {unitLabel(a.unit)}{a.unit === "diaria" && nights > 0 ? ` · ${nights} ${nights === 1 ? "diária" : "diárias"} = ${BRL(a.price * nights)}` : ""}</span>
                    </span>
                  </span>
                  {a.description && <span className="block text-xs text-slate-500 mt-1 line-clamp-2">{a.description}</span>}
                </label>
              </div>
              {p && a.category === "churrasco" && (
                <div className="flex items-center justify-between mt-2 pl-[4.25rem] text-xs text-slate-600">
                  <span>Quantidade de kits</span>
                  <Stepper value={p.qty} onChange={(q) => setPicked(picked.map((x) => (x.addon_id === a.id ? { ...x, qty: q } : x)))} max={10} testId={`addon-qty-${a.id}`} />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
